export const LocalizationActionTypes = {
    LOCALE_SPECIFIC_EN: 'LOCALE_SPECIFIC_EN',
    LOCALE_SPECIFIC_HE: 'LOCALE_SPECIFIC_HE',
};
